import { API_JWT_BASE_URL } from '../http'

export const GET_INSTALLER_API = `${API_JWT_BASE_URL}/ClientInstaller`

export const CLIENT_INSTALLER_KEYS = {
  GET_INSTALLER: 'GET_INSTALLER',
  DOWNLOAD: 'DOWNLOAD'
}
